export const listJobOpportunitys = /* GraphQL */ `
  query ListJobOpportunitys(
    $filter: ModelJobOpportunityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobOpportunitys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        customer {
          id
          family_name
          given_name
          username
          companyDetails {
            name
          }
        }
        customerOwner {
          id
          username
        }
        geographicalRegions {
          regionName
        }
        externalJobId
        sfdcExternalID
        jobLength
        jobLengthInWeeks
        jobType {
          id
          title
        }
        matches(limit: 1000) {
          items {
            status
            subStatus
          }
        }
        metadata
        maxRate {
          value
        }
        minRate {
          value
        }
        maxTalentRate {
          value
          currency
        }
        minTalentRate {
          value
          currency
        }
        maxSalary {
          value
        }
        minSalary {
          value
        }
        maxTalentSalary {
          value
          currency
        }
        minTalentSalary {
          value
          currency
        }
        optionalTKSkills {
          id
          category
          languageIsoCode
          name
        }
        intelSkills {
          id
          category
          languageIsoCode
          name
        }
        isDMP
        organization
        priorityLevel
        status
        title
        TKSkills {
          id
          category
          languageIsoCode
          name
        }
        torcOwner {
          id
          username
        }
        workMode
      }
      nextToken
    }
  }
`;
export const getJobOpportunity = /* GraphQL */ `
  query GetJobOpportunity(
    $id: ID!
    $documentTextTypeFilter: ModelStringKeyConditionInput
  ) {
    getJobOpportunity(id: $id) {
      metadata
      jobCreationDate
      organization
      customer {
        company
        sfdcCustomerStatus
        companyDetails {
          name
        }
        notes {
          items {
            id
          }
        }
      }
      employmentType
      externalJobId
      sfdcExternalID
      freelancerPitchPrefill
      torcOwner {
        username
      }
      id
      isDMP
      notesCount
      jobLength
      jobLengthInWeeks
      jobType {
        id
        title
      }
      maxRate {
        value
      }
      minRate {
        value
      }
      maxTalentRate {
        value
        currency
      }
      minTalentRate {
        value
        currency
      }
      maxSalary {
        value
      }
      minSalary {
        value
      }
      maxTalentSalary {
        value
        currency
      }
      minTalentSalary {
        value
        currency
      }
      optionalTKSkills {
        id
        category
        languageIsoCode
        name
      }
      intelSkills {
        id
        category
        languageIsoCode
        name
      }
      overview
      priorityLevel
      requirements
      requiredExperience
      responsibilities
      ropesProblems {
        id
        status
      }
      startDate
      status
      timeOverlap
      timeCommitment
      timezone {
        label
        value
      }
      title
      TKSkills {
        id
        category
        languageIsoCode
        name
      }
      location {
        cityName
        countryName
        stateName
        latitude
        longitude
        locationId
      }
      matches(limit: 50) {
        items {
          id
          applicationId
          availableStartDate
          createdAt
          creator
          customerRate {
            value
          }
          freelancerPitch
          freelancerPitchPrefill
          isAccepted
          jobOpportunityId
          matchAgent
          metadata
          notesCount
          rate {
            value
          }
          rating
          reasonsForRating
          resumeLocation
          status
          subStatus
          userId
          updater
          matcher
          updatedAt
          user {
            assessments {
              id
              assessmentCompleted
              codeScore
              createdAt
              finalScore
              multipleChoiceScore
              pdfResultLocation
              resultDetails {
                id
                analysis {
                  key
                  explanation
                  score
                  summary
                  name
                }
                integrityReport {
                  explanation
                  risk
                }
                interviewId
                ropesUserId
                score
                source
                testId
              }
              interviewId
              reportLink
              reportLinkExpiresAt
              source
              status
              testName
              timeTaken
              updatedAt
            }
            TKSkills {
              id
              category
              experience
              experienceYears
              languageIsoCode
              name
            }
            bio
            bullhornStatus
            createdAt
            lastActivityDate
            externalUserId
            careers {
              id
              TKSkills {
                id
                category
                experience
                experienceYears
                languageIsoCode
                name
              }
              companyName
              companyDomain
              description
              endDate
              format
              locationType
              # we want to keep legacy skills. Since careers is an array field we need to fetch the skills so in any update will be included.
              skills {
                experience
                name
              }
              stack
              startDate
              title
            }
            documentsText(type: $documentTextTypeFilter) {
              items {
                id
                paragraphs
                type
                userId
              }
            }
            educationRecords {
              id
              degreeType
              degreeName
              description
              endDate
              fieldOfStudy
              school
              startDate
            }
            certifications {
              id
              title
              issuingOrganization
              issuingOrganizationDomain
              issueDate
              expirationDate
              credentialId
              credentialUrl
              TKSkills {
                id
                category
                experience
                experienceYears
                languageIsoCode
                name
              }
            }
            email
            headshotKey
            username
            id
            talentSource
            additionalMarkup
            availability
            noticePeriod
            family_name
            given_name
            identity_username
            isUnclaimed
            location {
              cityName
              countryCode
              countryName
              stateName
            }
            profileCompletion
            metadata
            ratePerHour {
              currency
              value
            }
            salary {
              currency
              value
            }
            phone {
              number
              whatsAppAllowed
            }
            placements {
              id
              actualEndDate
              endDate
            }
            projectsCaseStudies {
              id
              client
              description
              endDate
              workType
              link
              stack
              startDate
              title
            }
            referrerCode
            resumeWorkHistory {
              id
              TKSkills {
                id
                category
                experience
                experienceYears
                languageIsoCode
                name
              }
              companyName
              companyDomain
              description
              endDate
              format
              locationType
              stack
              startDate
              title
            }
            knownLanguages {
              level
              language
            }
            placements {
              id
              actualEndDate
              createdAt
              companyName
              endDate
              jobOpportunityId
              startDate
              updatedAt
            }
            socialLinks {
              type
              value
            }
            status
            otherLinks {
              description
              name
              type
              value
              visibility
            }
            resumeLocation
            systemModTimestamp
            torcQualityStats
            workAuthorizations
          }
          userId
        }
        nextToken
      }
      geographicalRegions {
        regionName
        countryNames
      }
      workMode
    }
  }
`;

export const getNextJobOpportunityMatches = /* GraphQL */ `
  query GetNextJobOpportunityMatches(
    $id: ID!
    $nextToken: String
    $documentTextTypeFilter: ModelStringKeyConditionInput
    $matchFilter: ModelMatchFilterInput
    $matchLimit: Int
  ) {
    getJobOpportunity(id: $id) {
      id
      # Keep matches fields in sync with the createMatch mutation
      matches(limit: $matchLimit, nextToken: $nextToken, filter: $matchFilter) {
        items {
          id
          applicationId
          id
          availableStartDate
          createdAt
          creator
          customerRate {
            value
          }
          freelancerPitch
          freelancerPitchPrefill
          isAccepted
          jobOpportunityId
          matchAgent
          metadata
          notesCount
          rate {
            value
          }
          rating
          reasonsForRating
          resumeLocation
          status
          subStatus
          userId
          updater
          matcher
          updatedAt
          user {
            assessments {
              id
              assessmentCompleted
              codeScore
              createdAt
              finalScore
              multipleChoiceScore
              pdfResultLocation
              resultDetails {
                id
                analysis {
                  key
                  explanation
                  score
                  summary
                  name
                }
                integrityReport {
                  explanation
                  risk
                }
                interviewId
                ropesUserId
                score
                source
                testId
              }
              interviewId
              reportLink
              reportLinkExpiresAt
              source
              status
              testName
              timeTaken
              updatedAt
            }
            TKSkills {
              id
              category
              experience
              experienceYears
              languageIsoCode
              name
            }
            bio
            bullhornStatus
            createdAt
            lastActivityDate
            careers {
              id
              TKSkills {
                id
                category
                experience
                experienceYears
                languageIsoCode
                name
              }
              companyName
              companyDomain
              description
              endDate
              format
              locationType
              # we want to keep legacy skills. Since careers is an array field we need to fetch the skills so in any update will be included.
              skills {
                experience
                name
              }
              stack
              startDate
              title
            }
            documentsText(type: $documentTextTypeFilter) {
              items {
                id
                paragraphs
                type
                userId
              }
            }
            educationRecords {
              id
              degreeType
              degreeName
              description
              endDate
              fieldOfStudy
              school
              startDate
            }
            certifications {
              id
              title
              issuingOrganization
              issuingOrganizationDomain
              issueDate
              expirationDate
              credentialId
              credentialUrl
              TKSkills {
                id
                category
                experience
                experienceYears
                languageIsoCode
                name
              }
            }
            email
            headshotKey
            username
            id
            talentSource
            additionalMarkup
            availability
            noticePeriod
            family_name
            given_name
            identity_username
            isUnclaimed
            location {
              cityName
              countryCode
              countryName
              stateName
            }
            profileCompletion
            metadata
            ratePerHour {
              currency
              value
            }
            salary {
              currency
              value
            }
            phone {
              number
              whatsAppAllowed
            }
            placements {
              id
              actualEndDate
              endDate
            }
            projectsCaseStudies {
              id
              client
              description
              endDate
              workType
              link
              stack
              startDate
              title
            }
            referrerCode
            resumeWorkHistory {
              id
              TKSkills {
                id
                category
                experience
                experienceYears
                languageIsoCode
                name
              }
              companyName
              companyDomain
              description
              endDate
              format
              locationType
              stack
              startDate
              title
            }
            knownLanguages {
              level
              language
            }
            placements {
              id
              actualEndDate
              createdAt
              companyName
              endDate
              jobOpportunityId
              startDate
              updatedAt
            }
            socialLinks {
              type
              value
            }
            status
            otherLinks {
              description
              name
              type
              value
              visibility
            }
            resumeLocation
            systemModTimestamp
            torcQualityStats
            workAuthorizations
          }
          userId
        }
        nextToken
      }
    }
  }
`;

export const listSimilarJobOpportunities = /* GraphQL */ `
  query ListSimilarJobOpportunities(
    $query: String!
    $limit: Int = 5
    $preFilter: ModelSimilarJobOpportunityPreFilterInput
    $filter: ModelSimilarJobOpportunityFilterInput
    $matchFilter: ModelMatchFilterInput
    $matchNexToken: String
  ) {
    listSimilarJobOpportunities(
      query: $query
      limit: $limit
      preFilter: $preFilter
      filter: $filter
    ) {
      id
      customer {
        company
        companyDetails {
          name
        }
      }
      employmentType
      jobLength
      jobLengthInWeeks
      jobType {
        id
        title
      }
      maxRate {
        value
      }
      minRate {
        value
      }
      maxTalentRate {
        value
        currency
      }
      minTalentRate {
        value
        currency
      }
      maxSalary {
        value
      }
      minSalary {
        value
      }
      maxTalentSalary {
        value
        currency
      }
      minTalentSalary {
        value
        currency
      }
      matches(filter: $matchFilter, nextToken: $matchNexToken) {
        items {
          applicationId
          user {
            applications {
              items {
                isNotActive
                jobTypeId
                id
              }
            }
          }
          jobOpportunityId
          resumeLocation
          status
          subStatus
          userId
        }
        nextToken
      }
      optionalTKSkills {
        id
        category
        languageIsoCode
        name
      }
      intelSkills {
        id
        category
        languageIsoCode
        name
      }
      organization
      overview
      requirements
      responsibilities
      status
      timeOverlap
      timezone {
        label
        value
      }
      title
      TKSkills {
        id
        category
        languageIsoCode
        name
      }
      vectorSearchScore
    }
  }
`;
export const getMatch = /* GraphQL */ `
  query GetMatch($applicationId: ID!, $jobOpportunityId: ID!) {
    getMatch(
      applicationId: $applicationId
      jobOpportunityId: $jobOpportunityId
    ) {
      applicationId
      jobOpportunityId
      isAccepted
      resumeLocation
      status
      subStatus
      rate {
        value
      }
      userId
    }
  }
`;
export const listJobOpportunityMatches = /* GraphQL */ `
  query GetJobOpportunity(
    $id: ID!
    $matchFilter: ModelMatchFilterInput
    $matchNexToken: String
  ) {
    getJobOpportunity(id: $id) {
      id
      matches(filter: $matchFilter, nextToken: $matchNexToken) {
        items {
          applicationId
          user {
            applications {
              items {
                isNotActive
                id
              }
            }
          }
          jobOpportunityId
          resumeLocation
          status
          subStatus
          userId
        }
        nextToken
      }
    }
  }
`;
export const listJobOpportunityNotes = /* GraphQL */ `
  query ListJobOpportunityNotes(
    $jobOpportunityId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobOpportunityNotes(
      jobOpportunityId: $jobOpportunityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        applicationId
        content
        createdAt
        creator
        isPublic
        noteType
        userId
      }
      nextToken
    }
  }
`;
export const listUserNotes = /* GraphQL */ `
  query ListUserNotes(
    $userId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserNotes(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        createdAt
        creator
        isPublic
        createdAt
        applicationId
        userId
        metadata
        noteSubType
        noteType
      }
      nextToken
    }
  }
`;
export const listMatchNotes = /* GraphQL */ `
  query ListMatchNotes(
    $applicationId: ID
    $jobOpportunityId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMatchNotes(
      applicationId: $applicationId
      jobOpportunityId: $jobOpportunityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        creator
        isPublic
        createdAt
        applicationId
        userId
        noteType
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      notes {
        items {
          content
          creator
          isPublic
          createdAt
        }
      }
    }
  }
`;
export const getUserAssessments = /* GraphQL */ `
  query GetUserAssessments($id: ID!) {
    getUser(id: $id) {
      id
      assessments {
        id
        assessmentCompleted
        codeScore
        createdAt
        finalScore
        multipleChoiceScore
        pdfResultLocation
        resultDetails {
          id
          analysis {
            key
            explanation
            score
            summary
            name
          }
          integrityReport {
            explanation
            risk
          }
          interviewId
          ropesUserId
          score
          source
          testId
        }
        interviewId
        reportLink
        reportLinkExpiresAt
        source
        status
        testName
        timeTaken
        updatedAt
      }
    }
  }
`;
export const getFieldHistory = /* GraphQL */ `
  query GetFieldHistory(
    $entity: String
    $key: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFieldHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getFieldHistory(
      entity: $entity
      key: $key
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        oldValue
        newValue
        creator
        createdAt
      }
    }
  }
`;
export const getUserActivityHistory = /* GraphQL */ `
  query GetUserActivityHistory(
    $userId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getUserActivityHistory(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        eventName
        message
        createdAt
      }
      nextToken
    }
  }
`;

export const getUserByUsername = /* GraphQL */ `
  query GetUserByUsername(
    $username: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getUserByUsername(
      username: $username
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
      }
    }
  }
`;
export const getUserByEmail = /* GraphQL */ `
  query GetUserByEmail(
    $email: AWSEmail
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getUserByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        identity_username
        status
        username
      }
    }
  }
`;
export const getUserForEditByEmail = /* GraphQL */ `
  query GetUserByEmail($email: AWSEmail) {
    getUserByEmail(email: $email) {
      items {
        id
        username
        identity_username
        given_name
        family_name
        tagline
        bio
        ratePerHour {
          currency
          value
        }
        salary {
          currency
          value
        }
        location {
          wikiDataId
          cityName
          stateName
          countryCode
          locationId
          latitude
          stateId
          stateCode
          countryName
          countryId
          longitude
        }
        careers {
          id
          companyName
          companyDomain
          description
          endDate
          format
          locationType
          stack
          startDate
          title
          TKSkills {
            id
            category
            experience
            experienceYears
            languageIsoCode
            name
          }
          skills {
            experience
            name
          }
        }
        certifications {
          id
          title
          issuingOrganization
          issuingOrganizationDomain
          issueDate
          expirationDate
          credentialId
          credentialUrl
          TKSkills {
            id
            category
            experience
            experienceYears
            languageIsoCode
            name
          }
        }
        projectsCaseStudies {
          id
          client
          description
          endDate
          workType
          link
          stack
          startDate
          title
          TKSkills {
            id
            category
            experience
            experienceYears
            languageIsoCode
            name
          }
        }
      }
    }
  }
`;

export const getJobOpportunityEvents = /* GraphQL */ `
  query GetJobOpportunityEvents($id: ID!) {
    getJobOpportunityEvents(id: $id) {
      conferencing {
        provider
        details {
          password
          url
          meetingCode
        }
      }
      description
      end
      owner
      participants {
        email
        name
        status
      }
      start
      status
      title
    }
  }
`;

export const getCloudinarySignature = /* GraphQL */ `
  query GetCloudinarySignature(
    $publicId: String!
    $preset: String
    $context: String
  ) {
    getCloudinarySignature(
      publicId: $publicId
      preset: $preset
      context: $context
    ) {
      signature
      timestamp
      apiKey
    }
  }
`;

export const listCoderbyteAssessments = /* GraphQL */ `
  query ListCoderbyteAssessments {
    listCoderbyteAssessments {
      isClosed
      link
      testId
      testName
    }
  }
`;

export const listRopesProblems = /* GraphQL */ `
  query ListRopesProblems {
    listRopesProblems {
      link
      testId
      testName
    }
  }
`;

export const listSharedAssessmentsByUser = /* GraphQL */ `
  query ListSharedAssessmentsByUser(
    $userId: ID
    $testId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSharedAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSharedAssessmentsByUser(
      userId: $userId
      testId: $testId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        jobOpportunityId
        link
        testId
        testName
        userId
      }
      nextToken
    }
  }
`;

export const getMe = /* GraphQL */ `
  query GetMe {
    getMe {
      id
      agreedToTerms
      agreedToMarketing
      company
      companyDetails {
        address {
          city
          country
          line1
          line2
          postalCode
          state
        }
        billingEmail
        bio
        logo
        name
        tagline
        timezone {
          label
          value
        }
        url
      }
      coverPhoto
      creator
      displayName
      email
      family_name
      given_name
      headshotKey
      identity_username
      isVip
      jobRole
      locale
      location {
        cityName
        countryCode
        countryId
        countryName
        latitude
        locationId
        longitude
        stateCode
        stateId
        stateName
        wikiDataId
      }
      metadata
      otherLinks {
        createdAt
        creator
        description
        name
        type
        updatedAt
        updater
        value
        visibility
      }
      phone {
        number
        whatsAppAllowed
      }
      profileCompletion
      profileStats
      referralCode
      referralCount
      referrerCode
      referrerSource
      shirtSize
      socialLinks {
        type
        value
      }
      status
      tagline
      updater
      username
      userType
      visibility
    }
  }
`;

export const getCognitoGroupsForUser = /* GraphQL */ `
  query GetCognitoGroupsForUser($username: String!) {
    getCognitoGroupsForUser(username: $username) {
      groups
    }
  }
`;

export const getUserByReferralCode = /* GraphQL */ `
  query GetUserByReferralCode($referralCode: String!) {
    getUserByReferralCode(referralCode: $referralCode) {
      items {
        id
        username
        userType
      }
    }
  }
`;

export const search = /* GraphQL */ `
  query Search(
    $requests: String!
    $sffv: Boolean
    $metadata: AWSJSON
    $searchSource: SearchSource
  ) {
    search(
      requests: $requests
      sffv: $sffv
      metadata: $metadata
      searchSource: $searchSource
    )
  }
`;

export const getApplicationsForUser = /* GraphQL */ `
  query GetApplicationsForUser($userId: ID!, $nextToken: String) {
    getApplicationsForUser(userId: $userId, nextToken: $nextToken) {
      items {
        id
        isNotActive
      }
      nextToken
    }
  }
`;

export const getUserMatches = /* GraphQL */ `
  query GetUserMatches($userId: ID!, $nextToken: String) {
    getUserMatches(userId: $userId, nextToken: $nextToken) {
      items {
        id
        applicationId
        freelancerPitch
        jobOpportunity {
          id
          organization
          status
          title
        }
        jobOpportunityId
        matcher
        rate {
          value
        }
        status
        createdAt
        updatedAt
        reasonForAutoMatch
        resumeLocation
      }
      nextToken
    }
  }
`;

export const listIdealCandidatesForJob = /* GraphQL */ `
  query ListIdealCandidatesForJob(
    $jobOpportunityId: String!
    $limit: Int
    $requiredSkillsToOverride: [EMSISkillInput!]
    $optionalSkillsToOverride: [EMSISkillInput!]
    $requiredTKSkillsToOverride: [TKSkillInput!]
    $optionalTKSkillsToOverride: [TKSkillInput!]
    $distanceToBound: Int
    $basedOnWorkHistory: Boolean
    $ignoreBio: Boolean
    $mainRecordsSource: SearchSource
  ) {
    listIdealCandidatesForJob(
      jobOpportunityId: $jobOpportunityId
      limit: $limit
      requiredSkillsToOverride: $requiredSkillsToOverride
      optionalSkillsToOverride: $optionalSkillsToOverride
      requiredTKSkillsToOverride: $requiredTKSkillsToOverride
      optionalTKSkillsToOverride: $optionalTKSkillsToOverride
      distanceToBound: $distanceToBound
      basedOnWorkHistory: $basedOnWorkHistory
      ignoreBio: $ignoreBio
      mainRecordsSource: $mainRecordsSource
    ) {
      hits
    }
  }
`;

export const getJobOpportunityAISkillsForSearch = /* GraphQL */ `
  query GetJobOpportunityAISkillsForSearch($id: ID!, $noCache: Boolean) {
    getJobOpportunityAISkillsForSearch(id: $id, noCache: $noCache)
  }
`;

export const searchSkills = /* GraphQL */ `
  query SearchSkills($term: String!, $limit: Int = 5) {
    searchSkills(term: $term, limit: $limit) {
      id
      infoUrl
      name
      type {
        id
        name
      }
    }
  }
`;

export const searchTKSkills = /* GraphQL */ `
  query SearchTKSkills($term: String!, $limit: Int = 5) {
    searchTKSkills(term: $term, limit: $limit) {
      id
      category
      name
      languageIsoCode
    }
  }
`;

export const getJobOpportunityId = /* GraphQL */ `
  query GetJobOpportunityId($id: ID!, $source: EXTERNALDATASOURCE!) {
    getJobOpportunityId(id: $id, source: $source)
  }
`;

export const reRankHitsForJob = /* GraphQL */ `
  query ReRankHitsForJob($jobId: String, $hits: AWSJSON) {
    reRankHitsForJob(jobId: $jobId, hits: $hits)
  }
`;

export const listJobLongList = /* GraphQL */ `
  query ListJobLongList(
    $jobOpportunityId: ID
    $userId: ModelIDKeyConditionInput
    $filter: ModelJobLongListFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $documentTextTypeFilter: ModelStringKeyConditionInput
  ) {
    listJobLongList(
      jobOpportunityId: $jobOpportunityId
      userId: $userId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        jobOpportunityId
        userId
        convertedToMatch
        resumeLocation
        createdAt
        updatedAt
        user {
          assessments {
            id
            assessmentCompleted
            codeScore
            createdAt
            finalScore
            multipleChoiceScore
            pdfResultLocation
            resultDetails {
              id
              integrityReport {
                explanation
                risk
              }
            }
            interviewId
            reportLink
            reportLinkExpiresAt
            source
            status
            testName
            timeTaken
            updatedAt
          }
          TKSkills {
            id
            category
            experience
            experienceYears
            languageIsoCode
            name
          }
          bio
          bullhornStatus
          createdAt
          externalUserId
          careers {
            id
            TKSkills {
              id
              category
              experience
              experienceYears
              languageIsoCode
              name
            }
            companyName
            companyDomain
            description
            endDate
            format
            locationType
            # we want to keep legacy skills. Since careers is an array field we need to fetch the skills so in any update will be included.
            skills {
              experience
              name
            }
            stack
            startDate
            title
          }
          documentsText(type: $documentTextTypeFilter) {
            items {
              id
              paragraphs
              type
              userId
            }
          }
          educationRecords {
            id
            degreeType
            degreeName
            description
            endDate
            fieldOfStudy
            school
            startDate
          }
          certifications {
            id
            title
            issuingOrganization
            issuingOrganizationDomain
            issueDate
            expirationDate
            credentialId
            credentialUrl
            TKSkills {
              id
              category
              experience
              experienceYears
              languageIsoCode
              name
            }
          }
          email
          headshotKey
          username
          id
          talentSource
          additionalMarkup
          availability
          noticePeriod
          family_name
          given_name
          identity_username
          isUnclaimed
          location {
            cityName
            countryCode
            countryName
            stateName
            latitude
            longitude
          }
          profileCompletion
          metadata
          ratePerHour {
            currency
            value
          }
          salary {
            currency
            value
          }
          phone {
            number
            whatsAppAllowed
          }
          placements {
            id
            actualEndDate
            endDate
          }
          projectsCaseStudies {
            id
            client
            description
            endDate
            workType
            link
            stack
            startDate
            title
          }
          referrerCode
          resumeWorkHistory {
            id
            TKSkills {
              id
              category
              experience
              experienceYears
              languageIsoCode
              name
            }
            companyName
            companyDomain
            description
            endDate
            format
            locationType
            stack
            startDate
            title
          }
          knownLanguages {
            level
            language
          }
          placements {
            id
            actualEndDate
            createdAt
            companyName
            endDate
            jobOpportunityId
            startDate
            updatedAt
          }
          socialLinks {
            type
            value
          }
          status
          otherLinks {
            description
            name
            type
            value
            visibility
          }
          resumeLocation
          systemModTimestamp
          torcQualityStats
          workAuthorizations
        }
      }
      nextToken
    }
  }
`;
